import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';

// Self-hosted fonts (eliminates external Google Fonts requests for speed + privacy)
import '@fontsource/playfair-display/400.css';
import '@fontsource/playfair-display/600.css';
import '@fontsource/playfair-display/700.css';
import '@fontsource/playfair-display/800.css';
import '@fontsource/outfit/300.css';
import '@fontsource/outfit/400.css';
import '@fontsource/outfit/500.css';
import '@fontsource/outfit/600.css';

import App from './App';
import PrivacyPolicy from './pages/PrivacyPolicy';
import Challenge from './pages/Challenge';
import RecipePage from './pages/RecipePage';
import BlogIndex from './pages/BlogIndex';
import BlogPost from './pages/BlogPost';
import About from './pages/About';
import Contact from './pages/Contact';
import Terms from './pages/Terms';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from '@/components/ui/sonner';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<App />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/challenge" element={<Challenge />} />
        <Route path="/recipe/:slug" element={<RecipePage />} />
        <Route path="/blog" element={<BlogIndex />} />
        <Route path="/blog/:slug" element={<BlogPost />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/terms" element={<Terms />} />
      </Routes>
      <Toaster position="top-center" richColors />
    </BrowserRouter>
  </React.StrictMode>
);